module.exports = __webpack_public_path__ + "static/img/sidebar_bg.32967e6e.png";